import type { Skill } from '../skillsData';

export const cryptoskillPredictionMarketsBData: Skill[] = [
  {
    id: 'polymarket-builder',
    name: 'polymarket-builder',
    author: 'Polymarket Builder',
    authorHandle: '@polymarket_builder',
    tag: 'Skill',
    category: 'tools',
    description: 'Custom Polymarket market creation tool. Design event markets, configure resolution criteria, and launch decentralized prediction contracts.',
    downloads: 11200,
    stars: 834,
    installCommand: '> install the polymarket-builder skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/prediction-markets/polymarket-builder',
    usageExample: '> design event market\n> configure resolution\n> launch contract',
    detailedDescription: 'Polymarket Builder enables custom prediction market creation. Design event questions with unambiguous resolution criteria, configure initial liquidity and fee parameters, and launch markets on the Polymarket decentralized protocol with automated market maker initialization.',
  },
  {
    id: 'polymarket-cit-trading',
    name: 'polymarket-cit-trading',
    author: 'CIT Trading',
    authorHandle: '@cit_trading',
    tag: 'Skill',
    category: 'trading',
    description: 'CIT institutional trading on Polymarket. Block-sized execution, portfolio hedging, and algorithmic strategies for large prediction market positions.',
    downloads: 7800,
    stars: 587,
    installCommand: '> install the polymarket-cit-trading skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/prediction-markets/polymarket-cit-trading',
    usageExample: '> execute block trades\n> hedge portfolio\n> run algo strategies',
    detailedDescription: 'Polymarket CIT Trading provides institutional-grade execution for prediction markets. Execute large block trades with minimal market impact, hedge prediction portfolios against correlated macro events, and deploy algorithmic strategies including TWAP execution and smart order routing for event contracts.',
  },
  {
    id: 'polymarket-data-api',
    name: 'polymarket-data-api',
    author: 'Polymarket Data',
    authorHandle: '@polymarket_data',
    tag: 'Skill',
    category: 'analytics',
    description: 'Polymarket historical and real-time data API. Price history, volume analytics, trader behavior, and market resolution records.',
    downloads: 16500,
    stars: 1234,
    installCommand: '> install the polymarket-data-api skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/prediction-markets/polymarket-data-api',
    usageExample: '> get price history\n> analyze volume\n> study trader behavior',
    detailedDescription: 'Polymarket Data API provides comprehensive market data access. Retrieve historical price and volume data for backtesting, analyze trader behavior patterns including top performer wallets, and access market resolution records for model training and strategy validation.',
  },
  {
    id: 'polymarket-integration',
    name: 'polymarket-integration',
    author: 'Polymarket Integration',
    authorHandle: '@polymarket_int',
    tag: 'Skill',
    category: 'analytics',
    description: 'Full Polymarket platform integration. Market discovery, trading, portfolio management, and resolution tracking in unified interface.',
    downloads: 19800,
    stars: 1456,
    installCommand: '> install the polymarket-integration skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/prediction-markets/polymarket-integration',
    usageExample: '> discover markets\n> trade events\n> track resolutions',
    detailedDescription: 'Polymarket Integration provides unified access to the entire prediction market platform. Discover active and upcoming markets with advanced filtering, execute trades with various order types, manage portfolio exposure across multiple events, and track market resolutions with automated settlement handling.',
  },
  {
    id: 'polymarket-intelligence-agent',
    name: 'polymarket-intelligence-agent',
    author: 'Polymarket Intel',
    authorHandle: '@polymarket_intel',
    tag: 'Skill',
    category: 'tools',
    description: 'Intelligence agent for Polymarket. Multi-source signal aggregation, narrative detection, and alpha generation for event contract trading.',
    downloads: 13400,
    stars: 1012,
    installCommand: '> install the polymarket-intelligence-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/prediction-markets/polymarket-intelligence-agent',
    usageExample: '> aggregate signals\n> detect narratives\n> generate alpha',
    detailedDescription: 'Polymarket Intelligence Agent deploys multi-source signal aggregation for prediction markets. Monitor news APIs, social media sentiment, on-chain activity, and polling data in real-time. Detect emerging narratives before market pricing adjusts, and generate alpha signals with confidence scores for automated trading.',
  },
  {
    id: 'polymarket-intelligence',
    name: 'polymarket-intelligence',
    author: 'Polymarket Intel',
    authorHandle: '@polymarket_intel',
    tag: 'Skill',
    category: 'analytics',
    description: 'Polymarket market intelligence platform. Market analytics, trader profiling, and predictive modeling for decentralized event contracts.',
    downloads: 15600,
    stars: 1167,
    installCommand: '> install the polymarket-intelligence skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/prediction-markets/polymarket-intelligence',
    usageExample: '> analyze markets\n> profile traders\n> build prediction models',
    detailedDescription: 'Polymarket Intelligence provides comprehensive analytics for prediction market traders. Analyze market microstructure and liquidity dynamics, profile successful traders to identify alpha strategies, and build predictive models using historical market data for informed event contract positioning.',
  },
  {
    id: 'polymarket-mcp',
    name: 'polymarket-mcp',
    author: 'Polymarket MCP',
    authorHandle: '@polymarket_mcp',
    tag: 'Skill',
    category: 'tools',
    description: 'Polymarket Model Context Protocol server. Standardized AI agent interface for market data, trading, and analytics on decentralized prediction markets.',
    downloads: 17800,
    stars: 1323,
    installCommand: '> install the polymarket-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/prediction-markets/polymarket-mcp',
    usageExample: '> connect MCP server\n> query polymarket data\n> execute via protocol',
    detailedDescription: 'Polymarket MCP provides standardized Model Context Protocol access to prediction markets. Any AI agent can connect to query market metadata, prices, and order books; execute trades; and access analytics through standardized interfaces — enabling seamless AI integration with decentralized event contracts.',
  },
  {
    id: 'polymarket-odds',
    name: 'polymarket-odds',
    author: 'Polymarket Odds',
    authorHandle: '@polymarket_odds',
    tag: 'Skill',
    category: 'analytics',
    description: 'Real-time odds conversion and comparison for Polymarket. Convert share prices to decimal odds, compare with bookmakers, and identify value opportunities.',
    downloads: 12300,
    stars: 934,
    installCommand: '> install the polymarket-odds skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/prediction-markets/polymarket-odds',
    usageExample: '> convert to decimal odds\n> compare bookmakers\n> find value bets',
    detailedDescription: 'Polymarket Odds provides real-time odds analytics for prediction markets. Convert outcome share prices to familiar decimal and fractional odds formats, compare against traditional bookmaker pricing, and identify positive expected value opportunities where prediction market pricing exceeds fair value estimates.',
  },
  {
    id: 'polymarket-official-agent-skills',
    name: 'polymarket-official-agent-skills',
    author: 'Polymarket Official',
    authorHandle: '@polymarket',
    tag: 'Skill',
    category: 'tools',
    description: 'Official Polymarket agent skills. Market making, liquidity provision, and automated market resolution by the Polymarket team.',
    downloads: 24500,
    stars: 1789,
    installCommand: '> install the polymarket-official-agent-skills skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/prediction-markets/polymarket-official-agent-skills',
    usageExample: '> deploy official agent\n> provide liquidity\n> resolve markets',
    detailedDescription: 'Polymarket Official Agent Skills are maintained by the core team. Deploy officially supported market making agents with optimized pricing curves, provide liquidity to new markets for bootstrapping, and access automated market resolution tools with dispute handling for maintaining platform integrity.',
  },
  {
    id: 'polymarket-prediction-agent',
    name: 'polymarket-prediction-agent',
    author: 'Polymarket Predict',
    authorHandle: '@polymarket_predict',
    tag: 'Skill',
    category: 'tools',
    description: 'AI prediction agent for Polymarket. Event analysis, probability modeling, and automated position management on decentralized event contracts.',
    downloads: 18900,
    stars: 1423,
    installCommand: '> install the polymarket-prediction-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/prediction-markets/polymarket-prediction-agent',
    usageExample: '> analyze events\n> model probabilities\n> auto-manage positions',
    detailedDescription: 'Polymarket Prediction Agent deploys AI for autonomous prediction market trading. Analyze event parameters using news, polling, and historical data; model outcome probabilities with Bayesian networks; and automatically manage positions with dynamic sizing, stop-losses, and profit-taking based on conviction levels.',
  },
  {
    id: 'polymarket-prediction-integration',
    name: 'polymarket-prediction-integration',
    author: 'Polymarket Predict',
    authorHandle: '@polymarket_predict',
    tag: 'Skill',
    category: 'analytics',
    description: 'Integrated prediction suite for Polymarket. Multi-model forecasting, consensus aggregation, and systematic position allocation across events.',
    downloads: 14500,
    stars: 1089,
    installCommand: '> install the polymarket-prediction-integration skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/prediction-markets/polymarket-prediction-integration',
    usageExample: '> run multi-model forecast\n> aggregate consensus\n> allocate positions',
    detailedDescription: 'Polymarket Prediction Integration combines multiple forecasting models for event contract trading. Run parallel predictions from statistical, machine learning, and sentiment models; aggregate into consensus probabilities with uncertainty quantification; and allocate capital systematically across a diversified prediction portfolio.',
  },
  {
    id: 'polymarket-prediction-markets',
    name: 'polymarket-prediction-markets',
    author: 'Polymarket Markets',
    authorHandle: '@polymarket_markets',
    tag: 'Skill',
    category: 'analytics',
    description: 'Comprehensive Polymarket prediction market toolkit. Market scanning, outcome modeling, and portfolio analytics for event contract traders.',
    downloads: 21300,
    stars: 1567,
    installCommand: '> install the polymarket-prediction-markets skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/prediction-markets/polymarket-prediction-markets',
    usageExample: '> scan all markets\n> model outcomes\n> analyze portfolio',
    detailedDescription: 'Polymarket Prediction Markets provides a complete analytics toolkit for decentralized event contracts. Scan all active markets with category and expiration filtering, model outcome probabilities using fundamental and technical analysis, and track prediction portfolio performance with risk-adjusted return metrics.',
  },
  {
    id: 'polymarket-prediction',
    name: 'polymarket-prediction',
    author: 'Polymarket Predict',
    authorHandle: '@polymarket_predict',
    tag: 'Skill',
    category: 'analytics',
    description: 'Base prediction engine for Polymarket. Event probability estimation, base rate calculation, and outcome forecasting for binary event contracts.',
    downloads: 16700,
    stars: 1245,
    installCommand: '> install the polymarket-prediction skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/prediction-markets/polymarket-prediction',
    usageExample: '> estimate probability\n> calculate base rate\n> forecast outcomes',
    detailedDescription: 'Polymarket Prediction provides the foundational forecasting engine for event contracts. Estimate outcome probabilities using base rates from historical data, apply Bayesian updating as new information arrives, and forecast binary event outcomes with calibrated confidence intervals for informed prediction market positioning.',
  },
  {
    id: 'polymarket-research',
    name: 'polymarket-research',
    author: 'Polymarket Research',
    authorHandle: '@polymarket_research',
    tag: 'Skill',
    category: 'analytics',
    description: 'Research tools for Polymarket. Market design analysis, trader behavior studies, and platform efficiency metrics for prediction market researchers.',
    downloads: 8900,
    stars: 678,
    installCommand: '> install the polymarket-research skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/prediction-markets/polymarket-research',
    usageExample: '> analyze market design\n> study trader behavior\n> measure efficiency',
    detailedDescription: 'Polymarket Research provides academic-grade tools for prediction market analysis. Study market design parameters and their impact on liquidity, analyze trader behavior patterns including herding and informed trading, and measure platform efficiency metrics like price accuracy and market maker profitability.',
  },
  {
    id: 'polymarket-sdk',
    name: 'polymarket-sdk',
    author: 'Polymarket Dev',
    authorHandle: '@polymarket_dev',
    tag: 'Skill',
    category: 'tools',
    description: 'Official Polymarket SDK. TypeScript/JavaScript library for building prediction market applications with full platform access.',
    downloads: 23400,
    stars: 1678,
    installCommand: '> install the polymarket-sdk skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/prediction-markets/polymarket-sdk',
    usageExample: '> initialize SDK\n> query markets\n> execute trades',
    detailedDescription: 'Polymarket SDK is the official TypeScript/JavaScript library for prediction market development. Initialize authenticated sessions, query market metadata and prices, place and manage orders, and handle portfolio tracking — all with typed interfaces and comprehensive error handling for robust prediction market applications.',
  },
  {
    id: 'polymarket-sports-edge',
    name: 'polymarket-sports-edge',
    author: 'Polymarket Sports',
    authorHandle: '@polymarket_sports',
    tag: 'Skill',
    category: 'analytics',
    description: 'Sports prediction market edge detection. Statistical modeling, injury impact analysis, and weather-adjusted forecasts for sports events.',
    downloads: 15600,
    stars: 1167,
    installCommand: '> install the polymarket-sports-edge skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/prediction-markets/polymarket-sports-edge',
    usageExample: '> model sports events\n> analyze injuries\n> adjust for weather',
    detailedDescription: 'Polymarket Sports Edge provides specialized analytics for sports prediction markets. Model game outcomes using team statistics and player ratings, analyze injury impacts on win probability, and adjust forecasts for weather conditions — all to identify pricing edges in sports event contracts.',
  },
  {
    id: 'polymarket-trader-ai',
    name: 'polymarket-trader-ai',
    author: 'Polymarket AI',
    authorHandle: '@polymarket_ai',
    tag: 'Skill',
    category: 'trading',
    description: 'AI-powered Polymarket trader. Pattern recognition, sentiment analysis, and algorithmic execution for decentralized event contract trading.',
    downloads: 18900,
    stars: 1423,
    installCommand: '> install the polymarket-trader-ai skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/prediction-markets/polymarket-trader-ai',
    usageExample: '> recognize patterns\n> analyze sentiment\n> algo execute trades',
    detailedDescription: 'Polymarket Trader AI combines pattern recognition with sentiment analysis for prediction market trading. Identify recurring price patterns from historical data, analyze real-time social media and news sentiment for event impact assessment, and execute trades algorithmically with optimal timing for maximum edge capture.',
  },
  {
    id: 'polymarket-trading-bot-v2',
    name: 'polymarket-trading-bot-v2',
    author: 'Polymarket Bot',
    authorHandle: '@polymarket_bot',
    tag: 'Skill',
    category: 'trading',
    description: 'Advanced Polymarket trading bot v2. Multi-strategy execution, portfolio rebalancing, and automated market making for event contracts.',
    downloads: 21200,
    stars: 1567,
    installCommand: '> install the polymarket-trading-bot-v2 skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/prediction-markets/polymarket-trading-bot-v2',
    usageExample: '> run multi-strategy\n> rebalance portfolio\n> auto market make',
    detailedDescription: 'Polymarket Trading Bot v2 is an advanced automated trading system for prediction markets. Deploy multiple strategies simultaneously including momentum, mean reversion, and news-based trading; automatically rebalance portfolio exposure across events; and provide liquidity through optimized market making curves.',
  },
  {
    id: 'polymarket-trading-bot',
    name: 'polymarket-trading-bot',
    author: 'Polymarket Bot',
    authorHandle: '@polymarket_bot',
    tag: 'Skill',
    category: 'trading',
    description: 'Polymarket automated trading bot. Event-based signal detection, position automation, and risk management for prediction market trading.',
    downloads: 17800,
    stars: 1323,
    installCommand: '> install the polymarket-trading-bot skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/prediction-markets/polymarket-trading-bot',
    usageExample: '> detect event signals\n> auto-open positions\n> manage risk',
    detailedDescription: 'Polymarket Trading Bot automates prediction market trading. Detect trading signals from event calendars, news feeds, and price momentum; automatically open and close positions based on predefined criteria; and manage risk with stop-losses, position limits, and drawdown controls for sustainable event contract trading.',
  },
  {
    id: 'polymarket-trending-agent',
    name: 'polymarket-trending-agent',
    author: 'Polymarket Trends',
    authorHandle: '@polymarket_trends',
    tag: 'Skill',
    category: 'tools',
    description: 'Trend detection agent for Polymarket. Social momentum tracking, viral narrative identification, and early trend positioning in prediction markets.',
    downloads: 13400,
    stars: 1012,
    installCommand: '> install the polymarket-trending-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/prediction-markets/polymarket-trending-agent',
    usageExample: '> track social momentum\n> identify viral narratives\n> position early trends',
    detailedDescription: 'Polymarket Trending Agent detects emerging trends before they impact market pricing. Track social media momentum and discussion volume growth, identify viral narratives with potential to move markets, and automatically position in early-stage trends for maximum upside capture in prediction markets.',
  },
  {
    id: 'polymarket-trending',
    name: 'polymarket-trending',
    author: 'Polymarket Trends',
    authorHandle: '@polymarket_trends',
    tag: 'Skill',
    category: 'analytics',
    description: 'Polymarket trending markets dashboard. Real-time trending events, volume surges, and social buzz metrics for hot prediction markets.',
    downloads: 11200,
    stars: 845,
    installCommand: '> install the polymarket-trending skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/prediction-markets/polymarket-trending',
    usageExample: '> view trending markets\n> detect volume surges\n> monitor social buzz',
    detailedDescription: 'Polymarket Trending provides a real-time dashboard of hot prediction markets. Identify trending events through volume surge detection, monitor social media buzz and discussion growth, and track price momentum to discover markets gaining attention before mainstream awareness drives significant pricing moves.',
  },
  {
    id: 'polymarket-whale-copier',
    name: 'polymarket-whale-copier',
    author: 'Polymarket Whale',
    authorHandle: '@polymarket_whale',
    tag: 'Skill',
    category: 'trading',
    description: 'Copy successful Polymarket traders. Whale wallet tracking, performance analytics, and automated copy-trading for prediction markets.',
    downloads: 14500,
    stars: 1089,
    installCommand: '> install the polymarket-whale-copier skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/prediction-markets/polymarket-whale-copier',
    usageExample: '> track whale wallets\n> analyze performance\n> copy-trade positions',
    detailedDescription: 'Polymarket Whale Copier enables copy-trading of successful prediction market participants. Track high-performing wallet addresses, analyze their historical accuracy and risk-adjusted returns, and automatically mirror their positions with configurable scaling and risk limits for hands-off prediction market trading.',
  },
  {
    id: 'polymarket',
    name: 'polymarket',
    author: 'Polymarket',
    authorHandle: '@polymarket',
    tag: 'Skill',
    category: 'analytics',
    description: 'Core Polymarket prediction market access. Trade event outcome shares, provide liquidity, and participate in decentralized forecasting.',
    downloads: 35600,
    stars: 2134,
    installCommand: '> install the polymarket skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/prediction-markets/polymarket',
    usageExample: '> trade event shares\n> provide liquidity\n> participate in forecasting',
    detailedDescription: 'Polymarket provides core access to the leading decentralized prediction market platform. Trade outcome shares on real-world events across politics, sports, crypto, and culture. Provide liquidity to earn fees, participate in collective forecasting, and access transparent on-chain resolution for all market outcomes.',
  },
  {
    id: 'predi-agent',
    name: 'predi-agent',
    author: 'Predi Protocol',
    authorHandle: '@predi_protocol',
    tag: 'Skill',
    category: 'tools',
    description: 'Autonomous Predi prediction agent. AI-driven event analysis, probability estimation, and trade execution across multiple prediction platforms.',
    downloads: 7800,
    stars: 587,
    installCommand: '> install the predi-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/prediction-markets/predi-agent',
    usageExample: '> analyze cross-platform events\n> estimate probabilities\n> execute trades',
    detailedDescription: 'Predi Agent is an autonomous AI for multi-platform prediction market trading. Analyze events across Polymarket, Kalshi, and other venues simultaneously; estimate outcome probabilities using ensemble models; and execute trades on the most favorably priced platform for optimal execution and risk distribution.',
  },
  {
    id: 'predi-predictbase-agent',
    name: 'predi-predictbase-agent',
    author: 'Predi PredictBase',
    authorHandle: '@predi_predictbase',
    tag: 'Skill',
    category: 'tools',
    description: 'PredictBase agent for Predi. Market data aggregation, cross-platform arbitrage, and unified portfolio management for prediction markets.',
    downloads: 6200,
    stars: 467,
    installCommand: '> install the predi-predictbase-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/prediction-markets/predi-predictbase-agent',
    usageExample: '> aggregate market data\n> find cross-platform arb\n> manage unified portfolio',
    detailedDescription: 'Predi PredictBase Agent aggregates data across prediction market platforms. Collect real-time pricing from multiple venues, identify cross-platform arbitrage opportunities on the same events, and manage a unified prediction portfolio with consolidated PnL and risk exposure tracking across all connected platforms.',
  },
  {
    id: 'predi-predictbase',
    name: 'predi-predictbase',
    author: 'Predi PredictBase',
    authorHandle: '@predi_predictbase',
    tag: 'Skill',
    category: 'analytics',
    description: 'PredictBase prediction market data layer. Unified API for market discovery, pricing, and analytics across prediction market platforms.',
    downloads: 8900,
    stars: 678,
    installCommand: '> install the predi-predictbase skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/prediction-markets/predi-predictbase',
    usageExample: '> discover cross-platform markets\n> compare pricing\n> run unified analytics',
    detailedDescription: 'Predi PredictBase is a unified data layer for prediction markets. Discover equivalent markets across Polymarket, Kalshi, and other platforms; compare real-time pricing to find the best execution venue; and run unified analytics including volume aggregation and cross-platform correlation analysis.',
  },
  {
    id: 'predi-prediction-agent',
    name: 'predi-prediction-agent',
    author: 'Predi AI',
    authorHandle: '@predi_ai',
    tag: 'Skill',
    category: 'tools',
    description: 'AI prediction agent for Predi markets. Autonomous forecasting, signal generation, and systematic event contract trading.',
    downloads: 9500,
    stars: 712,
    installCommand: '> install the predi-prediction-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/prediction-markets/predi-prediction-agent',
    usageExample: '> forecast predi events\n> generate trading signals\n> execute systematically',
    detailedDescription: 'Predi Prediction Agent deploys AI for autonomous event contract trading. Generate forecasts using machine learning models trained on historical market data, create trading signals when model probabilities diverge from market pricing, and execute positions systematically with position sizing based on edge and confidence.',
  },
  {
    id: 'predi',
    name: 'predi',
    author: 'Predi Protocol',
    authorHandle: '@predi_protocol',
    tag: 'Skill',
    category: 'analytics',
    description: 'Predi prediction market protocol core. Market creation, outcome trading, and resolution management for decentralized event contracts.',
    downloads: 11200,
    stars: 845,
    installCommand: '> install the predi skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/prediction-markets/predi',
    usageExample: '> create predi market\n> trade outcomes\n> manage resolutions',
    detailedDescription: 'Predi is a decentralized prediction market protocol. Create custom event markets with configurable parameters and resolution criteria, trade outcome shares through automated market makers, and manage market resolutions through decentralized oracle networks with transparent dispute and appeal processes.',
  },
  {
    id: 'prediction-markets-router',
    name: 'prediction-markets-router',
    author: 'PM Router',
    authorHandle: '@pm_router',
    tag: 'Skill',
    category: 'tools',
    description: 'Cross-platform prediction market router. Optimal venue selection, best-price execution, and unified order management across prediction markets.',
    downloads: 13400,
    stars: 1012,
    installCommand: '> install the prediction-markets-router skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/prediction-markets/prediction-markets-router',
    usageExample: '> route to best venue\n> execute best price\n> manage unified orders',
    detailedDescription: 'Prediction Markets Router provides intelligent cross-platform execution. Automatically route orders to the prediction market venue offering the best price for equivalent events, execute trades with minimal slippage through order splitting, and manage unified order books across Polymarket, Kalshi, and other connected platforms.',
  },
  {
    id: 'sayeeda-signals',
    name: 'sayeeda-signals',
    author: 'Sayeeda Signals',
    authorHandle: '@sayeeda_signals',
    tag: 'Skill',
    category: 'analytics',
    description: 'Sayeeda prediction market signals. Technical indicator-based trading signals, momentum alerts, and trend reversal detection for event contracts.',
    downloads: 5800,
    stars: 437,
    installCommand: '> install the sayeeda-signals skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/prediction-markets/sayeeda-signals',
    usageExample: '> get trading signals\n> receive momentum alerts\n> detect trend reversals',
    detailedDescription: 'Sayeeda Signals provides technical analysis for prediction markets. Generate trading signals from price momentum, volume profile, and order flow indicators; receive real-time alerts when momentum shifts significantly; and detect trend reversal patterns specific to the unique dynamics of binary outcome event contracts.',
  },
  {
    id: 'suzu-parrot80',
    name: 'suzu-parrot80',
    author: 'Suzu Parrot',
    authorHandle: '@suzu_parrot',
    tag: 'Skill',
    category: 'tools',
    description: 'Conversational prediction market agent. Natural language event querying, probability estimation, and trade execution through chat interface.',
    downloads: 4200,
    stars: 318,
    installCommand: '> install the suzu-parrot80 skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/prediction-markets/suzu-parrot80',
    usageExample: '> chat about events\n> estimate probabilities\n> execute via chat',
    detailedDescription: 'Suzu Parrot80 is a conversational prediction market agent. Query events and receive probability estimates through natural language chat, ask follow-up questions to refine understanding, and execute trades directly from conversation context — making prediction market participation accessible to non-technical users.',
  },
  {
    id: 'taruki-kalshi',
    name: 'taruki-kalshi',
    author: 'Taruki Kalshi',
    authorHandle: '@taruki_kalshi',
    tag: 'Skill',
    category: 'trading',
    description: 'Taruki Kalshi trading integration. Event contract execution, portfolio tracking, and automated strategy deployment for regulated prediction markets.',
    downloads: 6700,
    stars: 512,
    installCommand: '> install the taruki-kalshi skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/prediction-markets/taruki-kalshi',
    usageExample: '> trade kalshi events\n> track portfolio\n> deploy strategies',
    detailedDescription: 'Taruki Kalshi provides comprehensive trading integration for regulated prediction markets. Execute trades on Kalshi event contracts with various order types, track portfolio performance with detailed PnL analytics, and deploy automated strategies including calendar-based event trading and post-event volatility strategies.',
  },
  {
    id: 'team-sayeeda-signals',
    name: 'team-sayeeda-signals',
    author: 'Team Sayeeda',
    authorHandle: '@team_sayeeda',
    tag: 'Skill',
    category: 'analytics',
    description: 'Collaborative prediction market signals. Team-based signal generation, consensus voting, and collective position management for group prediction trading.',
    downloads: 4900,
    stars: 378,
    installCommand: '> install the team-sayeeda-signals skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/prediction-markets/team-sayeeda-signals',
    usageExample: '> generate team signals\n> vote on consensus\n> manage collective positions',
    detailedDescription: 'Team Sayeeda Signals enables collaborative prediction market trading. Generate trading signals as a team through multi-member analysis, vote on position entry and exit decisions with consensus thresholds, and manage collective positions with transparent attribution and profit sharing for group prediction strategies.',
  },
  {
    id: 'the-odds-oracle',
    name: 'the-odds-oracle',
    author: 'The Odds Oracle',
    authorHandle: '@the_odds_oracle',
    tag: 'Skill',
    category: 'analytics',
    description: 'The Odds Oracle decentralized price feed. Aggregated odds from global betting markets converted to probability estimates for prediction market reference.',
    downloads: 10200,
    stars: 765,
    installCommand: '> install the the-odds-oracle skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/prediction-markets/the-odds-oracle',
    usageExample: '> aggregate global odds\n> convert to probabilities\n> serve as reference feed',
    detailedDescription: 'The Odds Oracle aggregates pricing from global betting markets and converts to probability estimates. Collect odds from hundreds of sportsbooks and exchanges worldwide, normalize to true probability estimates by removing vigorish, and serve as a reference data feed for prediction market pricing and oracle resolution.',
  },
  {
    id: 'theodds-oracle',
    name: 'theodds-oracle',
    author: 'TheOdds Oracle',
    authorHandle: '@theodds_oracle',
    tag: 'Skill',
    category: 'analytics',
    description: 'TheOdds Oracle v2. Enhanced odds aggregation with real-time updates, odds movement tracking, and arbitrage opportunity detection across betting markets.',
    downloads: 8900,
    stars: 678,
    installCommand: '> install the theodds-oracle skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/prediction-markets/theodds-oracle',
    usageExample: '> get real-time odds\n> track odds movements\n> detect arbitrage',
    detailedDescription: 'TheOdds Oracle v2 provides enhanced odds aggregation with real-time capabilities. Stream live odds updates from global betting markets, track odds movements to detect informed money flow, and identify arbitrage opportunities where pricing diverges significantly across venues or compared to prediction market pricing.',
  },
  {
    id: 'theoddsoracle',
    name: 'theoddsoracle',
    author: 'TheOddsOracle',
    authorHandle: '@theoddsoracle',
    tag: 'Skill',
    category: 'analytics',
    description: 'TheOddsOracle base protocol. Sports odds normalization, probability calibration, and prediction market pricing comparison for value identification.',
    downloads: 7600,
    stars: 578,
    installCommand: '> install the theoddsoracle skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/prediction-markets/theoddsoracle',
    usageExample: '> normalize sports odds\n> calibrate probabilities\n> compare with prediction markets',
    detailedDescription: 'TheOddsOracle base protocol provides foundational odds analytics. Normalize sports odds from diverse formats and sources, calibrate implied probabilities to account for bookmaker margins and biases, and compare against prediction market pricing to identify value opportunities and market inefficiencies.',
  },
];